export const API = "https://backend.tomexpress.jp/api/v1";

// export const API = "http://127.0.0.1:6512/api/v1"
export default {
    API,
}